import moment from 'moment-timezone';

export const SMS_UNAVAILABLE_REASONS = {
    UNPUBLISHED: 'unpublished',
    POST_EVENT_CUTOFF: 'post-event-cutoff',
    MISSING_TIMEZONE: 'missing-tz',
};

const CUTOFF_DISPLAY_FORMAT = 'MMM D, YYYY h:mm A z';

const SMS_UNAVAILABLE_MESSAGES = {
    [SMS_UNAVAILABLE_REASONS.UNPUBLISHED]: 'SMS is unavailable until the event is published.',
    [SMS_UNAVAILABLE_REASONS.POST_EVENT_CUTOFF]: 'The post-event SMS window has ended.',
    [SMS_UNAVAILABLE_REASONS.MISSING_TIMEZONE]: 'SMS is unavailable due to a missing event time zone.',
};

export const buildSmsUnavailableMessage = (reason, cutoffDisplay = null, prefixed = false) => {
    const base = reason === SMS_UNAVAILABLE_REASONS.POST_EVENT_CUTOFF && cutoffDisplay
        ? `The post-event SMS window ended on ${cutoffDisplay}.`
        : SMS_UNAVAILABLE_MESSAGES[reason] || 'SMS is currently unavailable.';

    if (prefixed && reason === SMS_UNAVAILABLE_REASONS.POST_EVENT_CUTOFF) {
        return `${buildSmsUnavailableMessage.POST_EVENT_CUTOFF_PREFIX}${base}`;
    }
    return base;
};

buildSmsUnavailableMessage.POST_EVENT_CUTOFF_PREFIX = 'SMS messaging is no longer available - ';

const blocked = (reason, cutoffDisplay = null) => ({
    canSend: false,
    reason,
    cutoffDisplay,
});

const AVAILABLE = { canSend: true, reason: null, cutoffDisplay: null };

export const getSmsSendingAvailability = (eventData) => {
    if (!eventData) {
        return blocked(SMS_UNAVAILABLE_REASONS.MISSING_TIMEZONE);
    }

    if (eventData.published !== true) {
        return blocked(SMS_UNAVAILABLE_REASONS.UNPUBLISHED);
    }

    const eventEndUtc = eventData?.eventSchedule?.eventEndUtc;
    if (!eventEndUtc) {
        return AVAILABLE;
    }

    const timeZone = eventData?.eventSchedule?.timeZone?.value || null;
    if (!timeZone) {
        return blocked(SMS_UNAVAILABLE_REASONS.MISSING_TIMEZONE);
    }

    const endOfDayAfterEvent = moment.utc(eventEndUtc).tz(timeZone).add(1, 'day').endOf('day');
    const nowInEventTz = moment().tz(timeZone);

    if (nowInEventTz.isAfter(endOfDayAfterEvent)) {
        return blocked(
            SMS_UNAVAILABLE_REASONS.POST_EVENT_CUTOFF,
            endOfDayAfterEvent.format(CUTOFF_DISPLAY_FORMAT),
        );
    }

    return AVAILABLE;
};
